import app from 'app';
import bfcmClockNewsletter from 'pages/page/bfcm-clock-newsletter';
import bfcmTextVideo from 'pages/page/bfcm-text-video';
import sidebar from 'pages/page/sidebar';

app.add({
  'page-sidebar': sidebar,
  'bfcm-clock-newsletter': bfcmClockNewsletter,
  'bfcm-text-video': bfcmTextVideo,
});
